import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import '../AdminGroups.css'

import Loader from "../../../Components/Loader";
import { GroupService } from "../../../DataService/GroupService";
import { AdminIcon } from "../../../Icons/AdminIcon";
import { GroupDto } from "../../../Types/GroupServiceTypes";
import GroupCard from "./GroupCard";
import CreateGroupModal from "./CreateGroupModal";
import { Button } from "../../../Components/Button";

const GroupsListPage: React.FC = () => {
  const [groups, setGroups] = useState<GroupDto[]>([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    setLoading(true);
    const data = await GroupService.GetGroups();
    if (data) setGroups(data);
    setLoading(false);
  };

  return (
    <div className="admin-page-shell admin-groups-page-shell">
      <header className="admin-page-header admin-groups-title-container">
        <div>
          <h1 className="admin-page-title admin-groups-title-text">Grupper</h1>
          <p className="admin-page-subtitle admin-groups-title-paragraph">Här hanterar du alla grupper.</p>
        </div>
        <Button size="sm" className="submit-button" onClick={() => setShowCreate(true)} text={<><AdminIcon.PlusSign width={18} fill="white"/> Skapa ny grupp</>} />
      </header>

        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", paddingTop: 40 }}>
            <Loader loaderSize="LARGE" bgColor="hsl(var(--primary))" />
          </div>
        ) : (
          <div className="admin-groups-tab-content-grid">
            {groups.map(g => (
              <GroupCard key={g.id} group={g} onOpen={() => navigate(`/admin/groups/${g.id}`)} onRefresh={load} />
            ))}
            {groups.length === 0 && <p>Inga grupper hittades.</p>}
          </div>
        )}

      {showCreate && (
        <CreateGroupModal
          onClose={() => setShowCreate(false)}
          onCreated={async () => { setShowCreate(false); await load(); }}
        />
      )}
    </div>
  );
};

export default GroupsListPage;
